// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2":"patient","123":"case","430":"doctor","857":"report"}[chunkId] + "." + {"2":"4f816d1f","123":"603420fc","430":"d47217c4","857":"1eb06d6e"}[chunkId] + ".css";
};